var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseSelect',{attrs:{"cclass":"page-list mr-1","value":_vm.currentFilter,"options":_vm.filterItems,"isSort":"","disabledHover":"","reverseArrow":"","defaultText":"generals.sort"},on:{"input":_vm.sortFunc}})}
var staticRenderFns = []

export { render, staticRenderFns }